import { Injectable } from "@angular/core";
import { JornadaPsicologo, JornadaPsicologoAtividade } from "../models/psicologo/JornadaPsicologo";

@Injectable({
  providedIn: 'root'
})
export class PsicologoUtilsService {

  constructor() { }

  calculaTotalHorasTrabalhadas(jornada?: JornadaPsicologo): Date {
    const horario = new Date(0, 0, 0, 0, 0);
    if (!jornada)
      return horario;

    const dataInicio = jornada?.stAjusteAprovacaoEntrada == 1
      ? new Date(jornada!.hrAjusteEntrada!)
      : new Date(jornada!.dataInicio);

    const dataFimBase = jornada?.stAjusteAprovacaoSaida == 1
      ? (jornada?.hrAjusteSaida ? new Date(jornada.hrAjusteSaida) : undefined)
      : (jornada?.dataFim ? new Date(jornada.dataFim) : undefined);

    if (!dataFimBase)
      return horario;

    // CA-08/CA-09: checkout considera DataFim/DataAjustada sem segundos, somando apenas deslocamento.
    dataFimBase.setSeconds(0, 0);
    dataInicio.setSeconds(0, 0);

    const diffEmMinutos = Math.max(0, Math.floor((dataFimBase.getTime() - dataInicio.getTime()) / 60000));
    horario.setMinutes(diffEmMinutos);

    const tempoDeslocamento = this.calculaTempoDeslocamento(jornada);
    horario.setHours(horario.getHours() + tempoDeslocamento.getHours())
    horario.setMinutes(horario.getMinutes() + tempoDeslocamento.getMinutes())

    return horario;
  }

  hasTipoPessoa(atividade: JornadaPsicologoAtividade, tipoPessoa: number): boolean {
    return atividade.envolvidos.some(envolvido => envolvido.tipoPessoa === tipoPessoa);
  }


  calculaTotalHorasTempoRegistro(jornada?: JornadaPsicologo): Date {

    const horario = new Date(0, 0, 0, 0, 0);
    if (!jornada)
      return horario;

    const atividades = jornada.atividades;

    if (atividades.length === 0) {
      return horario;
    }

    atividades.forEach(atividade => {
      const tempoAtividade = atividade.tempoRegistro.split(':');
      const minutes = parseInt(tempoAtividade[0], 10);
      const seconds = parseInt(tempoAtividade[1], 10);
      horario.setMinutes(horario.getMinutes() + minutes);
      horario.setSeconds(horario.getSeconds() + seconds);
    })
    return horario;
  }


  calculaTempoDeslocamento(jornada?: JornadaPsicologo):Date{
   const horario = new Date(0, 0, 0, 0, 0);
    if (!jornada )
      return horario;

     if (!jornada.deslocamento )
      return horario;


    const parseHorario = (horario: string): Date => {
        const [hora, minuto] = horario.split(":").map(Number);
        return new Date(0, 0, 0, hora, minuto);
      };

      const horaOrigem = parseHorario(jornada.deslocamento.horarioSaida);
      const horaDestino = parseHorario(jornada.deslocamento.horarioChegada);

      const diffHoras = horaDestino.getHours() - horaOrigem.getHours();
      const diffMinutos = horaDestino.getMinutes() - horaOrigem.getMinutes();

      horario.setHours(horario.getHours() + diffHoras);
      horario.setMinutes(horario.getMinutes() + diffMinutos);
      return horario;
  }
}
